import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const NotFound = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Page Not Found - Appstoria';

    let metaRobots = document.querySelector('meta[name="robots"]');
    const createdMeta = !metaRobots;
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.setAttribute('name', 'robots');
      document.head.appendChild(metaRobots);
    }
    const previousContent = metaRobots.getAttribute('content');
    metaRobots.setAttribute('content', 'noindex, follow');

    return () => {
      document.title = previousTitle;
      if (createdMeta) {
        metaRobots.remove();
      } else if (previousContent !== null) {
        metaRobots.setAttribute('content', previousContent);
      } else {
        metaRobots.remove();
      }
    };
  }, []);

  return (
    <>
      <Header />
      <main style={{ padding: '80px 24px', textAlign: 'center', minHeight: '40vh' }}>
        <h1>Page not found</h1>
        <p>The page you're looking for doesn't exist or has moved.</p>
        <p>
          <Link to="/">Return to the homepage</Link>
        </p>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
